import React, { useEffect, useState } from "react";
import { Breaker, Button, Flexbox, InputField} from "../../Theme/GlobalStyles";
import { Text } from "../../Theme/Typography";
import { CloseCircle } from "../../Theme/Icons";
import { globalTheme } from "../../Theme/Theme";
import { PopupBody, PopupWrapper } from "./CommonPopup";
import { clearCoworkSliceStates, coworkData, getAllAmenities, postTower } from "../../../redux/cowork/coworkSlice";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
const EditAmenityPopup =({isActive,togglePopup})=>{
    const [amenityName, setAmenityName] = useState("");
    
    const dispatch = useDispatch();
    const {
    isCoworkSliceFetching,
    isCoworkSliceSuccess,
    isCoworkSliceError,
    coworkSliceErrorMessage,
    } = useSelector(coworkData);

    useEffect(() => {
    if (!isActive) return;
    setAmenityName("");
    }, [isActive]);

    useEffect(() => {
    if (isActive && isCoworkSliceSuccess) {
        // Refresh the amenities list so the new option appears in the dropdown
        dispatch(getAllAmenities());
        dispatch(clearCoworkSliceStates());
        togglePopup(false);
    }
    }, [isCoworkSliceSuccess]);

    useEffect(() => {
    if (isCoworkSliceError) {
        toast.error(coworkSliceErrorMessage, {
        autoClose: 3000,
        hideProgressBar: false,
        pauseOnHover: true,
        });
        dispatch(clearCoworkSliceStates());
    }
    }, [isCoworkSliceError, coworkSliceErrorMessage]);

    const addAmenity = () => {
    if (!amenityName?.trim()) {
        toast.error("Please enter an amenity name", {
        autoClose: 3000,
        hideProgressBar: false,
        pauseOnHover: true,
        });
        return;
    }
    // The /add-towerAndAmenities endpoint accepts amenities without a tower name.
    dispatch(postTower({ amenities: amenityName.trim() }));
    };
    
return(
        <PopupWrapper className={`${isActive ? 'active' : ''}`}>
    <PopupBody maxWidth={480} padding={24}>
        <Flexbox spaceBW alignCenter>
            <Text font18 inter semiBold white maxWidth='max-content'>Add New Amenity</Text>
            <CloseCircle className={'pointer'} onClick={()=> togglePopup(false)}/>
        </Flexbox>
        <Breaker marginTop={16} marginBottom={20} borderColor={globalTheme.colors.white1}/>
        <Flexbox flexEnd>
            <InputField
                label="Amenity Name"
                isImp
                placeholder="Enter Amenity Name"
                onChange={(e) => setAmenityName(e.target.value)}
                value={amenityName}
            />
        </Flexbox>
        <Flexbox alignCenter gap={12} justiCenter className='mt20'>
            <Button
                whiteFilled
                buttonMd
                name={"Cancel"}
                disabled={isCoworkSliceFetching}
                onClick={() => togglePopup(false)}
            />
            <Button
                primaryFilled
                buttonMd
                name={"Add Amenity"}
                onClick={addAmenity}
                disabled={isCoworkSliceFetching}
                isLoading={isCoworkSliceFetching}
            />
        </Flexbox>
    </PopupBody>
    </PopupWrapper>
)
}
export default EditAmenityPopup;